import Konva from 'konva';
import React from 'react';
import { Group } from 'react-konva';
import { SpotGhostItem } from '../../SpotGhostItem';
import { SvgGhostItem } from '../../SvgGhostItem';
import { useMapEditor } from '../../contexts/MapEditorContext';

export interface MapCanvasGhostLayersProps {
  isMouseIn: boolean;
  iconToolGhostRef: React.RefObject<Konva.Group>;
}

export const MapCanvasGhostLayers: React.FC<MapCanvasGhostLayersProps> = ({
  isMouseIn,
  iconToolGhostRef
}) => {
  if (!isMouseIn) return;

  const { iconToolSelectedIcon, furnitureToolSelectedFurniture, activeTool } =
    useMapEditor();

  return (
    <Group opacity={0.5}>
      {iconToolSelectedIcon && activeTool === 'icon' && (
        <SvgGhostItem
          icon={iconToolSelectedIcon}
          ref={iconToolGhostRef as never}
        />
      )}
      {furnitureToolSelectedFurniture && activeTool === 'furniture' && (
        <SvgGhostItem
          furniture={furnitureToolSelectedFurniture}
          ref={iconToolGhostRef as never}
        />
      )}
      {activeTool === 'spot' && <SpotGhostItem ref={iconToolGhostRef} />}
    </Group>
  );
};
